import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { HeadingDesktop as Heading } from '@alfa-bank/site-heading/desktop';
import { Tag } from '@alfa-bank/site-tag';
import { Button } from '@alfa-bank/site-button';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { InputAutocomplete as Autocomplete } from '@alfa-bank/site-input-autocomplete';
import { AlfaleasingPromoCard as Card } from '@alfa-bank/site-alfaleasing-promo-card';

import { BrandBar } from '../components/brand-bar';
import { BrandList } from '../components/brand-list';
import { AlfaleasingPromotionsCatalog as Component } from '../alfaleasing-promotions-catalog';
import type { TAlfaleasingPromotionsCatalog, IDeps } from '../models';

import styles from './desktop.css';

// eslint-disable-next-line
export const AlfaleasingPromotionsCatalogDesktop = createWidget<
    IDeps,
    TAlfaleasingPromotionsCatalog
>({
    Autocomplete,
    BrandBar,
    BrandList,
    Button,
    Card,
    Heading,
    Tag,
    Layout,
    isSearchVisible: false,
    styles,
})(Component);
